import { useCallback, useEffect, useState } from "react";
import { useDensity } from "../store/density";
import { useI18n } from "../i18n";
import { canSpeak, speak, stopSpeaking } from "../lib/speak";

/**
 * 읽어 주기(SE) — 피코 말풍선·학생 배너는 SE 에서 읽어 주기 대상이다(SCR v0.6 · SR-NFR-06).
 * 음성은 ./speak(Bench shared/speak.ts 이식)로 낸다. 말할 수 없는 브라우저면 버튼을 두지 않는다.
 */
export function ReadAloudButton({ text, force }: { text: string; force?: boolean }) {
  const { density } = useDensity();
  const { t, locale } = useI18n();
  const [speaking, setSpeaking] = useState(false);
  const able = canSpeak();

  useEffect(() => () => stopSpeaking(), []);

  const onClick = useCallback(() => {
    if (speaking) {
      stopSpeaking();
      setSpeaking(false);
      return;
    }
    setSpeaking(true);
    speak(text, locale === "ko" ? "ko-KR" : "en-US", { onEnd: () => setSpeaking(false) });
  }, [speaking, text, locale]);

  if (!able || !text || (density !== "se" && !force)) return null;
  return (
    <button
      type="button"
      className="pf-read-aloud"
      onClick={onClick}
      aria-pressed={speaking}
      aria-label={speaking ? t("common.stopReading") : t("common.readAloud")}
    >
      <span aria-hidden="true">{speaking ? "⏹" : "🔊"}</span>
    </button>
  );
}
